function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement, forwardRef } from "react";
import { Box, Flex, Text } from "sprout-ui-primitives";
import { media, themeGet } from "sprout-ui-theme";
import styled, { css } from "styled-components";
const OptionsWrapper = styled(Box)`
  cursor: pointer;
  user-select: none;

  ${({ $disabled  })=>$disabled ? css`
          color: ${themeGet("colors.black.16")};
          cursor: not-allowed;
        ` : css`
          ${media.target("pointer")} {
            &:hover {
              background: ${themeGet("colors.black.4")};
            }
          }

          &[aria-selected="true"],
          &:active {
            background: ${themeGet("colors.black.12")};
          }
        `}
`;
const iconSize = css`
  width: 24px;
  height: 24px;
`;
const IconWrapper = styled(Flex)`
  ${iconSize};
  svg {
    ${iconSize};
  }
`;
const Option = /*#__PURE__*/ forwardRef(function OptionForwardRef(props, ref) {
    const { label , description , icon , disabled , appendLabel  } = props, rest = _objectWithoutProperties(props, [
        "label",
        "description",
        "icon",
        "disabled",
        "appendLabel"
    ]);
    return /*#__PURE__*/ _jsxs(OptionsWrapper, _objectSpread({
        borderRadius: "8px",
        p: "8px",
        color: "black.87",
        ref: ref,
        $disabled: !!disabled
    }, rest, {
        children: [
            /*#__PURE__*/ _jsxs(Flex, {
                alignItems: "center",
                children: [
                    icon && /*#__PURE__*/ _jsx(IconWrapper, {
                        flex: "none",
                        mr: "16px",
                        children: /*#__PURE__*/ createElement(icon)
                    }),
                    /*#__PURE__*/ _jsx(Box, {
                        children: /*#__PURE__*/ _jsx(Text, _objectSpread({}, !!icon && {
                            fontSize: "15px",
                            lineHeight: "24px",
                            fontWeight: "medium"
                        }, {
                            children: label
                        }))
                    }),
                    appendLabel
                ]
            }),
            description && /*#__PURE__*/ _jsx(Box, _objectSpread({}, icon && {
                ml: "40px"
            }, {
                children: /*#__PURE__*/ _jsx(Text, {
                    fontSize: 1,
                    lineHeight: "18px",
                    color: "black.60",
                    children: description
                })
            }))
        ]
    }));
});
export default Option;
